__turbopack_context__.v({
  "button": "MainWarehouseFilters-module-scss-module__HGBcea__button",
  "container": "MainWarehouseFilters-module-scss-module__HGBcea__container",
  "distanceFormItemWrapper": "MainWarehouseFilters-module-scss-module__HGBcea__distanceFormItemWrapper",
  "form": "MainWarehouseFilters-module-scss-module__HGBcea__form",
  "formItem": "MainWarehouseFilters-module-scss-module__HGBcea__formItem",
  "formItemWrapper": "MainWarehouseFilters-module-scss-module__HGBcea__formItemWrapper",
  "label": "MainWarehouseFilters-module-scss-module__HGBcea__label",
  "locationFormItemWrapper": "MainWarehouseFilters-module-scss-module__HGBcea__locationFormItemWrapper",
  "mobileTitle": "MainWarehouseFilters-module-scss-module__HGBcea__mobileTitle",
  "optionItem": "MainWarehouseFilters-module-scss-module__HGBcea__optionItem",
  "skeletonItem": "MainWarehouseFilters-module-scss-module__HGBcea__skeletonItem",
  "skeletonWrapper": "MainWarehouseFilters-module-scss-module__HGBcea__skeletonWrapper",
  "tempFormItemWrapper": "MainWarehouseFilters-module-scss-module__HGBcea__tempFormItemWrapper",
  "weightFormItemWrapper": "MainWarehouseFilters-module-scss-module__HGBcea__weightFormItemWrapper",
});
